var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocial2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_3358"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "aqua",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social",
    transform: "translate(0 0.203)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, -0.2)",
    filter: "url(#Path_3358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3358-2",
    "data-name": "Path 3358",
    d: "M21,0A21,21,0,1,1,0,21,21,21,0,0,1,21,0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M3.525,15.75H.26V5.235H3.525ZM1.891,3.8A1.9,1.9,0,1,1,3.782,1.892,1.907,1.907,0,0,1,1.891,3.8ZM15.746,15.75H12.488V10.631c0-1.22-.025-2.784-1.7-2.784-1.7,0-1.958,1.325-1.958,2.7V15.75H5.571V5.235H8.7V6.669h.046a3.431,3.431,0,0,1,3.089-1.7c3.3,0,3.912,2.176,3.912,5V15.75Z",
    transform: "translate(13.125 13.124)",
    fill: "aqua"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial2);
export default __webpack_public_path__ + "static/media/social2.2d867b507e661ca76344330df22fe913.svg";
export { ForwardRef as ReactComponent };